export enum InstallCodeEvent {
  TechnologiesDetectionFailed = 'Technologies detection failed',
}

export enum FailReason {
  EmptyUrl = 'empty company URL',
}
